<div *ngIf="!userVM" class="loadingMessage">
  <h1>Loading...</h1>
</div>

<div class="content" *ngIf="userVM">
  <div class="title">
    &larr; <a routerLink="/users/list" class="row-header"> Back to all users</a>
    <span>Create a New User</span>
  </div>

  <div class="user-form">
    <div>
      <user-form [userVM]="userVM"></user-form>
    </div>
  </div>
</div>
